import React, { useState, useContext } from 'react';
import { UserContext } from '../components/UserContext';

const CreateRoomModal = ({ onClose, onCreate }) => {
  const { user } = useContext(UserContext); 
  const [roomName, setRoomName] = useState('');
  const [roomType, setRoomType] = useState('public');
  const [roomKey, setRoomKey] = useState('');
  const [gameMode, setGameMode] = useState('single');
  const [numTeams, setNumTeams] = useState(2);
  const [playersPerTeam, setPlayersPerTeam] = useState(5);
  const [maxPlayers, setMaxPlayers] = useState(5);
  const [error, setError] = useState('');
  const playerName = user?.username || 'Guest_' + Math.floor(Math.random() * 1000);
  const playerId = user?.user_id || crypto.randomUUID();

  const validateForm = () => {
    if (!roomName.trim()) return 'Room Name is required';
    if (!roomType) return 'Room Type is required';
    if (roomType === 'private' && !roomKey.trim()) return 'Room Key is required';
    if (!gameMode) return 'Game Mode is required';

    if (gameMode === 'team') {
      if (!numTeams || !playersPerTeam) return 'Team settings are required';
    } else if (gameMode === 'single') {
      if (!maxPlayers) return 'Max Players is required';
    }

    return '';
  };

  const handleSubmit = () => {
    const validation = validateForm();
    if (validation) {
      setError(validation);
      return;
    }

    const roomData = {
      roomName,
      roomType,
      roomKey: roomType === 'private' ? roomKey : null,
      gameMode,
      teamSettings: gameMode === 'team' ? { numTeams, playersPerTeam } : null,
      maxPlayers: gameMode === 'single' ? maxPlayers : null,
      createdBy: {
        id: playerId,
        name: playerName,
        role: 'host',
        score: 0,
        status: 'waiting',
      }
    };
    

    onCreate(roomData);
    onClose();
  };

  return (
    <div className="fixed inset-0 p-4 sm:p-6 bg-black bg-opacity-60 flex items-center justify-center z-20">
      <div className="bg-yellow relative backdrop-blur-md rounded-xl w-full max-w-full sm:max-w-xl p-6 sm:p-8 shadow-xl transition-all duration-300 animate-fade-in text-black" >

        <div className="flex justify-end">
          <button
            onClick={onClose}
              className="relative w-10 h-10 flex items-center text-center justify-center text-3xl
                rounded-full bg-[#FF1111] shadow-[0_6px_0_#C30F0F] text-[#FFCC21] font-extrabold
                active:translate-y-[2px] active:shadow-none
                transition-all duration-200 ease-in-out
                hover:scale-[1.03]
                hover:brightness-110"
            >
            ✕
          </button>
        </div>

        <h2 className="text-3xl font-bold text-center mb-4">Create Game</h2>
  
        {error && <p className="text-black-500 mb-3 text-sm text-center">{error}</p>}
  
        <div className="text-left mb-4">
          <label className="block text-sm font-medium mb-1 roboto-f">Room Name:</label>
          <input 
            className="w-full py-2 px-4 rounded-full bg-white shadow-[0px_4px_6px_rgba(0,0,0,0.25)] border border-[#FFA600] focus:outline-none focus:ring-2 focus:ring-indigo-500"
            value={roomName}
            onChange={(e) => setRoomName(e.target.value)}
            placeholder="Room name"
          />
        </div>
  
        <div className="text-left mb-4">
        <label className="block text-sm font-medium mb-1 roboto-f">Room Type:</label>
          <div className="flex gap-6 mb-4 ">
            <label className="flex items-center gap-2 roboto-f">
              <input
                type="radio"
                name="roomType"
                value="public"
                checked={roomType === 'public'}
                onChange={() => setRoomType('public')}
              />
              Public
            </label>
            <label className="flex items-center gap-2 roboto-f">
              <input
                type="radio"
                name="roomType"
                value="private"
                checked={roomType === 'private'}
                onChange={() => setRoomType('private')}
              />
              Private
            </label>
          </div>
        </div>

        {roomType === 'private' && (
          <>
            <div className="text-left mb-4">
              <label className="block text-sm font-medium mb-1 roboto-f">Room Key:</label>
                <input
                  className="w-full mb-4 py-2 px-4 rounded-full bg-white shadow-[0px_4px_6px_rgba(0,0,0,0.25)] border border-[#FFA600] focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  value={roomKey}
                  onChange={(e) => setRoomKey(e.target.value)}
                  placeholder="Room key"
                />
            </div>
            
          </>
        )}
        <div className="text-left mb-4">
          <label className="block text-sm font-medium mb-1 roboto-f">Game Mode:</label>
            <div className="flex gap-6 mb-4">
                <label className="flex items-center gap-2 roboto-f">
                  <input
                    type="radio"
                    name="gameMode"
                    value="single"
                    checked={gameMode === 'single'}
                    onChange={() => setGameMode('single')}
                  />
                  Single Team Play
                </label>
              <label className="flex items-center gap-2 roboto-f">
                <input
                  type="radio"
                  name="gameMode"
                  value="team"
                  checked={gameMode === 'team'}
                  onChange={() => setGameMode('team')}
                />
                Inter-Team Play
              </label>
            </div>
        </div>

  
        {gameMode === 'team' && (
          <div className="grid grid-cols-2 gap-4 mb-6">
            <div>
              <label className="block text-sm font-medium mb-1 roboto-f">Number of Teams:</label>
              <input
                type="number"
                min="1"
                value={numTeams}
                onChange={(e) => setNumTeams(e.target.value)}
                className="w-full py-2 px-4 rounded-full bg-white shadow-[0px_4px_6px_rgba(0,0,0,0.25)] border border-[#FFA600] focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1 roboto-f">Players per Team:</label>
              <input
                type="number"
                min="1"
                value={playersPerTeam}
                onChange={(e) => setPlayersPerTeam(e.target.value)}
                className="w-full py-2 px-4 rounded-full bg-white shadow-[0px_4px_6px_rgba(0,0,0,0.25)] border border-[#FFA600] focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </div>
          </div>
        )}
  
        {gameMode === 'single' && (
          <>
            <div className="text-left mb-6">
                <label className="block text-sm font-medium mb-1 roboto-f">Max Players:</label>
                <input
                  type="number"
                  min="1"
                  value={maxPlayers}
                  onChange={(e) => setMaxPlayers(e.target.value)}
                  className="w-full py-2 px-4 rounded-full bg-white shadow-[0px_4px_6px_rgba(0,0,0,0.25)] border border-[#FFA600] focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
            </div>
          </>
        )}
  
        <div className="flex justify-center">
          <button
            className="font-bold relative inline-block px-4 sm:px-6 py-2 sm:py-3 text-white font-bold text-base sm:text-lg 
              bg-[#FF1111] rounded-2xl shadow-[0_6px_0_0_#C30F0F]
              transition-all duration-150 ease-in-out
              hover:scale-[1.03]
              hover:brightness-110
              active:translate-y-[4px] active:shadow-none"
                onClick={handleSubmit}
            >
            Create
          </button>
        </div>
      </div>
    </div>
  );
  
};

export default CreateRoomModal;
